// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-footer {
    background-color: var(--color-dark-background) !important;
}

.spinner-layer {
    border-color: #ffffff !important;
}

.switch label input[type='checkbox']:checked+.lever:after {
    background-color: rgb(255, 255, 255) !important;
}

/* Text inputs */
input:not([type]),
input[type='text']:not(.browser-default),
input[type='password']:not(.browser-default),
input[type='email']:not(.browser-default),
input[type='url']:not(.browser-default),
input[type='time']:not(.browser-default),
input[type='date']:not(.browser-default),
input[type='datetime']:not(.browser-default),
input[type='datetime-local']:not(.browser-default),
input[type='tel']:not(.browser-default),
input[type='number']:not(.browser-default),
input[type='search']:not(.browser-default),
textarea.materialize-textarea {
    border-bottom: 1px solid #ffffff !important;
    color: #ffffff;
    -webkit-appearance: none;
}

.btn,
.btn-large,
.btn-small {
    background-color: var(--color-primary);
}

.btn:hover,
.btn-large:hover,
.btn-small:hover {
    background-color: var(--color-primary-light);
}

.btn:focus,
.btn-large:focus,
.btn-small:focus,
.btn-floating:focus {
    background-color: var(--color-primary-dark);
}

.switch label input[type='checkbox']:checked+.lever {
    background-color: var(--color-primary) !important;
}

.dropdown-content li>a,
.dropdown-content li>span {
    color: var(--color-primary) !important;
    font-size: 14px !important;
}

.toast {
    border-radius: 0px !important;
    min-height: 4.25rem !important;
}

.select-wrapper input.select-dropdown {
    height: 2rem !important;
    line-height: 2rem !important;
}

.row {
    margin-bottom: 1rem;
}

.input-field {
    margin-top: 1rem 0 0 0;
    padding-left: 1rem;
    padding-right: 1rem;
}

.input-field.col label {
    padding-top: 0px;
}

input:not([type]):focus:not([readonly])+label,
input[type='text']:not(.browser-default):focus:not([readonly])+label,
input[type='password']:not(.browser-default):focus:not([readonly])+label,
input[type='email']:not(.browser-default):focus:not([readonly])+label,
input[type='url']:not(.browser-default):focus:not([readonly])+label,
input[type='time']:not(.browser-default):focus:not([readonly])+label,
input[type='date']:not(.browser-default):focus:not([readonly])+label,
input[type='datetime']:not(.browser-default):focus:not([readonly])+label,
input[type='datetime-local']:not(.browser-default):focus:not([readonly])+label,
input[type='tel']:not(.browser-default):focus:not([readonly])+label,
input[type='number']:not(.browser-default):focus:not([readonly])+label,
input[type='search']:not(.browser-default):focus:not([readonly])+label,
textarea.materialize-textarea:focus:not([readonly])+label {
    color: var(--color-dark-text-accent);
}

input:not([type]):disabled+label,
input:not([type])[readonly='readonly']+label,
input[type='text']:not(.browser-default):disabled+label,
input[type='text']:not(.browser-default)[readonly='readonly']+label,
input[type='password']:not(.browser-default):disabled+label,
input[type='password']:not(.browser-default)[readonly='readonly']+label,
input[type='email']:not(.browser-default):disabled+label,
input[type='email']:not(.browser-default)[readonly='readonly']+label,
input[type='url']:not(.browser-default):disabled+label,
input[type='url']:not(.browser-default)[readonly='readonly']+label,
input[type='time']:not(.browser-default):disabled+label,
input[type='time']:not(.browser-default)[readonly='readonly']+label,
input[type='date']:not(.browser-default):disabled+label,
input[type='date']:not(.browser-default)[readonly='readonly']+label,
input[type='datetime']:not(.browser-default):disabled+label,
input[type='datetime']:not(.browser-default)[readonly='readonly']+label,
input[type='datetime-local']:not(.browser-default):disabled+label,
input[type='datetime-local']:not(.browser-default)[readonly='readonly']+label,
input[type='tel']:not(.browser-default):disabled+label,
input[type='tel']:not(.browser-default)[readonly='readonly']+label,
input[type='number']:not(.browser-default):disabled+label,
input[type='number']:not(.browser-default)[readonly='readonly']+label,
input[type='search']:not(.browser-default):disabled+label,
input[type='search']:not(.browser-default)[readonly='readonly']+label,
textarea.materialize-textarea:disabled+label,
textarea.materialize-textarea[readonly='readonly']+label {
    color: var(--color-dark-text-muted)
}

input:not([type]):disabled,
input:not([type])[readonly='readonly'],
input[type='text']:not(.browser-default):disabled,
input[type='text']:not(.browser-default)[readonly='readonly'],
input[type='password']:not(.browser-default):disabled,
input[type='password']:not(.browser-default)[readonly='readonly'],
input[type='email']:not(.browser-default):disabled,
input[type='email']:not(.browser-default)[readonly='readonly'],
input[type='url']:not(.browser-default):disabled,
input[type='url']:not(.browser-default)[readonly='readonly'],
input[type='time']:not(.browser-default):disabled,
input[type='time']:not(.browser-default)[readonly='readonly'],
input[type='date']:not(.browser-default):disabled,
input[type='date']:not(.browser-default)[readonly='readonly'],
input[type='datetime']:not(.browser-default):disabled,
input[type='datetime']:not(.browser-default)[readonly='readonly'],
input[type='datetime-local']:not(.browser-default):disabled,
input[type='datetime-local']:not(.browser-default)[readonly='readonly'],
input[type='tel']:not(.browser-default):disabled,
input[type='tel']:not(.browser-default)[readonly='readonly'],
input[type='number']:not(.browser-default):disabled,
input[type='number']:not(.browser-default)[readonly='readonly'],
input[type='search']:not(.browser-default):disabled,
input[type='search']:not(.browser-default)[readonly='readonly'],
textarea.materialize-textarea:disabled,
textarea.materialize-textarea[readonly='readonly'] {
    color: var(--color-dark-text-muted)
}

.input-field>label {
    color: var(--color-dark-text-muted);
}

@media only screen and (min-width: 601px) {

    nav,
    nav .nav-wrapper i,
    nav a.sidenav-trigger,
    nav a.sidenav-trigger i {
        height: 64px;
        line-height: 64px;
    }
}`, "",{"version":3,"sources":["webpack://./public/css/materialize-local.css"],"names":[],"mappings":"AAAA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+CAA+C;AACnD;;AAEA,gBAAgB;AAChB;;;;;;;;;;;;;IAaI,2CAA2C;IAC3C,cAAc;IACd,wBAAwB;AAC5B;;AAEA;;;IAGI,sCAAsC;AAC1C;;AAEA;;;IAGI,4CAA4C;AAChD;;AAEA;;;;IAII,2CAA2C;AAC/C;;AAEA;IACI,iDAAiD;AACrD;;AAEA;;IAEI,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;;IAaI,oCAAoC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;IA0BI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;IA0BI;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI;;;;QAII,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".page-footer {\n    background-color: var(--color-dark-background) !important;\n}\n\n.spinner-layer {\n    border-color: #ffffff !important;\n}\n\n.switch label input[type='checkbox']:checked+.lever:after {\n    background-color: rgb(255, 255, 255) !important;\n}\n\n/* Text inputs */\ninput:not([type]),\ninput[type='text']:not(.browser-default),\ninput[type='password']:not(.browser-default),\ninput[type='email']:not(.browser-default),\ninput[type='url']:not(.browser-default),\ninput[type='time']:not(.browser-default),\ninput[type='date']:not(.browser-default),\ninput[type='datetime']:not(.browser-default),\ninput[type='datetime-local']:not(.browser-default),\ninput[type='tel']:not(.browser-default),\ninput[type='number']:not(.browser-default),\ninput[type='search']:not(.browser-default),\ntextarea.materialize-textarea {\n    border-bottom: 1px solid #ffffff !important;\n    color: #ffffff;\n    -webkit-appearance: none;\n}\n\n.btn,\n.btn-large,\n.btn-small {\n    background-color: var(--color-primary);\n}\n\n.btn:hover,\n.btn-large:hover,\n.btn-small:hover {\n    background-color: var(--color-primary-light);\n}\n\n.btn:focus,\n.btn-large:focus,\n.btn-small:focus,\n.btn-floating:focus {\n    background-color: var(--color-primary-dark);\n}\n\n.switch label input[type='checkbox']:checked+.lever {\n    background-color: var(--color-primary) !important;\n}\n\n.dropdown-content li>a,\n.dropdown-content li>span {\n    color: var(--color-primary) !important;\n    font-size: 14px !important;\n}\n\n.toast {\n    border-radius: 0px !important;\n    min-height: 4.25rem !important;\n}\n\n.select-wrapper input.select-dropdown {\n    height: 2rem !important;\n    line-height: 2rem !important;\n}\n\n.row {\n    margin-bottom: 1rem;\n}\n\n.input-field {\n    margin-top: 1rem 0 0 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n\n.input-field.col label {\n    padding-top: 0px;\n}\n\ninput:not([type]):focus:not([readonly])+label,\ninput[type='text']:not(.browser-default):focus:not([readonly])+label,\ninput[type='password']:not(.browser-default):focus:not([readonly])+label,\ninput[type='email']:not(.browser-default):focus:not([readonly])+label,\ninput[type='url']:not(.browser-default):focus:not([readonly])+label,\ninput[type='time']:not(.browser-default):focus:not([readonly])+label,\ninput[type='date']:not(.browser-default):focus:not([readonly])+label,\ninput[type='datetime']:not(.browser-default):focus:not([readonly])+label,\ninput[type='datetime-local']:not(.browser-default):focus:not([readonly])+label,\ninput[type='tel']:not(.browser-default):focus:not([readonly])+label,\ninput[type='number']:not(.browser-default):focus:not([readonly])+label,\ninput[type='search']:not(.browser-default):focus:not([readonly])+label,\ntextarea.materialize-textarea:focus:not([readonly])+label {\n    color: var(--color-dark-text-accent);\n}\n\ninput:not([type]):disabled+label,\ninput:not([type])[readonly='readonly']+label,\ninput[type='text']:not(.browser-default):disabled+label,\ninput[type='text']:not(.browser-default)[readonly='readonly']+label,\ninput[type='password']:not(.browser-default):disabled+label,\ninput[type='password']:not(.browser-default)[readonly='readonly']+label,\ninput[type='email']:not(.browser-default):disabled+label,\ninput[type='email']:not(.browser-default)[readonly='readonly']+label,\ninput[type='url']:not(.browser-default):disabled+label,\ninput[type='url']:not(.browser-default)[readonly='readonly']+label,\ninput[type='time']:not(.browser-default):disabled+label,\ninput[type='time']:not(.browser-default)[readonly='readonly']+label,\ninput[type='date']:not(.browser-default):disabled+label,\ninput[type='date']:not(.browser-default)[readonly='readonly']+label,\ninput[type='datetime']:not(.browser-default):disabled+label,\ninput[type='datetime']:not(.browser-default)[readonly='readonly']+label,\ninput[type='datetime-local']:not(.browser-default):disabled+label,\ninput[type='datetime-local']:not(.browser-default)[readonly='readonly']+label,\ninput[type='tel']:not(.browser-default):disabled+label,\ninput[type='tel']:not(.browser-default)[readonly='readonly']+label,\ninput[type='number']:not(.browser-default):disabled+label,\ninput[type='number']:not(.browser-default)[readonly='readonly']+label,\ninput[type='search']:not(.browser-default):disabled+label,\ninput[type='search']:not(.browser-default)[readonly='readonly']+label,\ntextarea.materialize-textarea:disabled+label,\ntextarea.materialize-textarea[readonly='readonly']+label {\n    color: var(--color-dark-text-muted)\n}\n\ninput:not([type]):disabled,\ninput:not([type])[readonly='readonly'],\ninput[type='text']:not(.browser-default):disabled,\ninput[type='text']:not(.browser-default)[readonly='readonly'],\ninput[type='password']:not(.browser-default):disabled,\ninput[type='password']:not(.browser-default)[readonly='readonly'],\ninput[type='email']:not(.browser-default):disabled,\ninput[type='email']:not(.browser-default)[readonly='readonly'],\ninput[type='url']:not(.browser-default):disabled,\ninput[type='url']:not(.browser-default)[readonly='readonly'],\ninput[type='time']:not(.browser-default):disabled,\ninput[type='time']:not(.browser-default)[readonly='readonly'],\ninput[type='date']:not(.browser-default):disabled,\ninput[type='date']:not(.browser-default)[readonly='readonly'],\ninput[type='datetime']:not(.browser-default):disabled,\ninput[type='datetime']:not(.browser-default)[readonly='readonly'],\ninput[type='datetime-local']:not(.browser-default):disabled,\ninput[type='datetime-local']:not(.browser-default)[readonly='readonly'],\ninput[type='tel']:not(.browser-default):disabled,\ninput[type='tel']:not(.browser-default)[readonly='readonly'],\ninput[type='number']:not(.browser-default):disabled,\ninput[type='number']:not(.browser-default)[readonly='readonly'],\ninput[type='search']:not(.browser-default):disabled,\ninput[type='search']:not(.browser-default)[readonly='readonly'],\ntextarea.materialize-textarea:disabled,\ntextarea.materialize-textarea[readonly='readonly'] {\n    color: var(--color-dark-text-muted)\n}\n\n.input-field>label {\n    color: var(--color-dark-text-muted);\n}\n\n@media only screen and (min-width: 601px) {\n\n    nav,\n    nav .nav-wrapper i,\n    nav a.sidenav-trigger,\n    nav a.sidenav-trigger i {\n        height: 64px;\n        line-height: 64px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
